module.exports = __webpack_public_path__ + "static/hill_giant_thief-f8204e0cf0e655bac68eb53e0be066e2.jpg";